export function Spinner({ full = false }: { full?: boolean }) {
  const spinner = (
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-white/20 border-t-gold" />
  );
  if (!full) return spinner;
  return (
    <div className="flex min-h-screen items-center justify-center bg-felt-dark">
      {spinner}
    </div>
  );
}
